import { render, staticRenderFns } from "./category-events-create.vue?vue&type=template&id=4d4fbaa5&"
import script from "./category-events-create.vue?vue&type=script&lang=js&"
export * from "./category-events-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports